import { Injectable, signal } from '@angular/core';

/**
 * Overlay bloqueante global.
 * SOLO se usa para mutaciones (POST / PUT / DELETE).
 * Los GET de listado usan el `loading` local de cada servicio (skeletons).
 */
@Injectable({ providedIn: 'root' })
export class SpinnerService {
  readonly loading = signal(false);
  readonly message = signal('Cargando...');

  show(message = 'Cargando...'): void {
    this.message.set(message);
    this.loading.set(true);
  }

  hide(): void {
    this.loading.set(false);
    this.message.set('Cargando...');
  }
}
